export default "__VITE_ASSET__BMlJfsrl__"